import type {ActionResponse} from 'typings/portaro.be.types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {actionRequestMethods, responseTypes} from '../constants/portaro.constants';
import type FinishedResponseInteractionService from './finished-response-interaction.service';
import type ActionRequestDataService from './action-request-data.service';

export default class ActionRequestService {
    public static serviceName = 'actionRequestService';

    /*@ngInject*/
    constructor(private actionRequestDataService: ActionRequestDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    @ngAsync()
    public async action(requestPath: string,
                        requestMethod: string = actionRequestMethods.GET,
                        requestBody?: any,
                        successCallback?: ($actionResponse: ActionResponse) => void): Promise<void> {
        try {
            const actionResponse: ActionResponse = await this.actionRequestDataService.request(requestPath, requestMethod, requestBody);

            if (successCallback) {
                successCallback(actionResponse);
                return;
            }
            return await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);

        } catch (actionResponse) {
            if (actionResponse.responseType !== responseTypes.INTERRUPT) {
                this.finishedResponseInteractionService.showFailedResponseInToast(actionResponse);
            }
            throw actionResponse;
        }
    }

}
